/* eslint-disable no-new */

import Vue from 'vue'
import Vuelidate from 'vuelidate'

import NewsApp from './news/Template/App.vue'
import { Municipality, SiteHeader, LoginDialog } from '@jdi-clients/cb-components'

import FaqApp from './faq/Template/App.vue'
import FaqStore from './faq/Store/store'
import FaqSearchBar from './faq/Components/FaqSearchBar.vue'
import FaqMain from './faq/Components/FaqMain.vue'
import FaqItem from './faq/Components/FaqItem.vue'

import WasteTypeWizard from './wizard/Template/App.vue'
import WasteStore from './wizard/Store/store'
import WasteTypeSearch from './wizard/Components/WasteTypeSearch.vue'
import WasteStreams from './wizard/Components/WasteStreams.vue'
import WasteTypeDetail from './wizard/Components/WasteTypeDetail.vue'
import Errors from './wizard/Components/Errors.vue'

import Maps from './maps/Components/Maps.vue'

import Message from 'element-ui/lib/message'

import './scss/main.scss'
import './scss/vendors/vendors.scss'

/**
 * For more information about the specific options
 * @url https://vuejs.org/v2/api/
 *
 * During development you want this to be true, so that you are aware that the build includes warnings
 * @bool false Vue.config.productionTip
 *
 * During development you want this to be true, so that you can use Developer Tools
 * @bool true Vue.config.devtools
 *
 * During development you want this to be false, so that Vue gives you hints about your code
 * @bool true Vue.config.silent
 *
 * Set this to true to enable component init, compile, render and patch performance tracing in the browser devtool performance/timeline panel.
 * Only works in development mode and in browsers that support the performance.mark API.
 * @bool false Vue.config.performance
 */

if (process.env.NODE_ENV === 'production') {
  Vue.config.productionTip = false
  Vue.config.devtools = false
  Vue.config.silent = true
  Vue.config.performance = false
  Vue.prototype.$message = Message
} else {
  Vue.config.productionTip = false
  Vue.config.devtools = true
  Vue.config.silent = false
  Vue.config.performance = false
  Vue.prototype.$message = Message
}

Vue.use(Vuelidate)

if (document.querySelector('#site-header')) {
  new Vue({
    components: {
      SiteHeader
    }
  }).$mount('#site-header')
}

if (document.querySelector('#municipality')) {
  new Vue({
    components: {
      Municipality
    },
    data() {
      return {
        isOpen: false
      }
    }
  }).$mount('#municipality')
}

if (document.querySelector('#vueApp')) {
  new Vue({
    components: {
      mailform: () => import('./mailform/components/c-mailform.vue')
    }
  }).$mount('#vueApp')
}

if (document.querySelector('#news-box')) {
  new Vue({
    el: '#news-box',
    components: {
      NewsApp
    },
    data() {
      return {
        excludedNewsItemId: null,
        newsApiUrl: undefined,
        municipalityApiUrl: undefined,
        municipalityId: null,
        showMunicipalitySelection: false
      }
    },
    beforeMount() {
      const { newsApiUrl, municipalityApiUrl, showMunicipalitySelection, excludedNewsItemId } = this.$el.dataset
      if (newsApiUrl === undefined) {
        /* eslint-disable-next-line */
        console.error('Missing "data-news-api-url" on element')
      } else {
        this.newsApiUrl = newsApiUrl
      }
      if (municipalityApiUrl === undefined) {
        /* eslint-disable-next-line */
        console.error('Missing "data-municipality-api-url" on element')
      } else {
        this.municipalityApiUrl = municipalityApiUrl
      }
      this.showMunicipalitySelection = showMunicipalitySelection === 'true'
      this.excludedNewsItemId = excludedNewsItemId === '' ? null : parseInt(excludedNewsItemId)
    },
    template: `<NewsApp />`
  })
}

if (document.querySelector('#municipality-news-box')) {
  new Vue({
    el: '#municipality-news-box',
    components: {
      NewsApp
    },
    data() {
      return {
        excludedNewsItemId: null,
        newsApiUrl: undefined,
        municipalityApiUrl: undefined,
        municipalityId: undefined,
        showMunicipalitySelection: false
      }
    },
    beforeMount() {
      const { newsApiUrl, municipalityApiUrl, municipalityId, showMunicipalitySelection, excludedNewsItemId } = this.$el.dataset
      if (newsApiUrl === undefined) {
        /* eslint-disable-next-line */
        console.error('Missing "data-news-api-url" on element')
      } else {
        this.newsApiUrl = newsApiUrl
      }
      if (municipalityApiUrl === undefined) {
        /* eslint-disable-next-line */
        console.error('Missing "data-municipality-api-url" on element')
      } else {
        this.municipalityApiUrl = municipalityApiUrl
      }
      this.municipalityId = municipalityId === '' ? null : parseInt(municipalityId)
      this.excludedNewsItemId = excludedNewsItemId === '' ? null : parseInt(excludedNewsItemId)
      this.showMunicipalitySelection = showMunicipalitySelection === 'true'
    },
    template: `<NewsApp />`
  })
}

if (document.querySelector('#FaqInstance')) {
  new Vue({
    FaqStore,
    el: '#FaqInstance',
    components: {
      FaqApp,
      FaqSearchBar,
      FaqMain,
      FaqItem
    }
  })
}

if (document.querySelector('#WasteTypeWizard')) {
  new Vue({
    el: '#WasteTypeWizard',
    WasteStore,
    components: {
      WasteTypeWizard,
      WasteTypeSearch,
      WasteStreams,
      WasteTypeDetail,
      Message,
      Errors
    }
  })
}

if (document.querySelector('#MapsApp')) {
  new Vue({
    el: '#MapsApp',
    components: {
      Maps
    }
  })
}

const loginDialogTriggers = document.querySelectorAll('.login-dialog')

if (loginDialogTriggers.length) {
  const instanceContainer = document.createElement('div')
  const component = document.createElement('login-dialog')
  instanceContainer.id = 'login-dialog'
  component.setAttribute('base-api-uri', window.urlMyCb)
  component.setAttribute('rel-path-my-cb-authenticate-zipcode', window.relPathMyCbAuthenticateZipcode)
  component.setAttribute('rel-path-my-cb-authenticate', window.relPathMyCbAuthenticate)
  instanceContainer.append(component)
  document.querySelector('body').append(instanceContainer)

  setTimeout(() => {
    new Vue({
      components: {
        LoginDialog
      }
    }).$mount('#login-dialog')
  }, 250)
}
